<div class="flex justify-content-center flex-wrap">
    <div class="flex align-items-center justify-content-center w-3 h-4rem font-bold border-round m-2 text-3xl">
        {{displayHeader}}
    </div>
</div>

<div class="flex justify-content-start flex-wrap mb-3">
    <button pButton type="button" label="Back" (click)="navigateToPartner()" icon="pi pi-angle-left"
        iconPos="left"></button>
</div>

<p-card>
    <form [formGroup]="newPartnerForm" class="centered">

        <div class="formgrid grid">
            <div class="field col-12 md:col-4">
                <label for="partnerId" class="required-field">Partner ID : </label>
                <div>
                    <input id="partnerId" type="text" pInputText formControlName="partnerId" class="w-10">
                </div>
                <div *ngIf="!newPartnerForm.controls['partnerId'].valid && newPartnerForm.controls['partnerId'].dirty"
                    class="error-msg">
                    <span *ngIf="newPartnerForm.controls['partnerId']?.hasError('required')">
                        Partner ID is required</span>
                    <span *ngIf="newPartnerForm.controls['partnerId']?.hasError('pattern')">
                        Partner ID should contain alphanumeric and special characters _@$#!
                        
                        </span>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label for="partnerName" class="required-field">Partner Name : </label>
                <input id="partnerName" type="text" pInputText formControlName="partnerName" class="w-10">
                <div *ngIf="!newPartnerForm.controls['partnerName'].valid && newPartnerForm.controls['partnerName'].dirty"
                    class="error-msg">
                    <span *ngIf="newPartnerForm.controls['partnerName']?.hasError('required')">
                        Partner Name is required</span>
                    <span *ngIf="newPartnerForm.controls['partnerName']?.hasError('pattern')">
                        Partner Name should be alphanumeric</span>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label for="isTopconPartner">Is Topcon Partner : </label>
                <div>
                    <p-checkbox name="isTopconPartner" formControlName="isTopconPartner" [binary]="true" class="w-10"
                        (onChange)="onChangeTopcon($event)"></p-checkbox>
                </div>
            </div>


            <div class="field col-12 md:col-4">
                <label for="email" class="required-field">Email :</label>
                <div>
                    <input id="city" type="text" class="w-10" pInputText formControlName="email">
                    <div *ngIf="!newPartnerForm.controls['email'].valid && newPartnerForm.controls['email'].dirty"
                        class="error-msg">
                        <span *ngIf="newPartnerForm.controls['email']?.hasError('required')">
                            Email is required</span>
                        <span *ngIf="newPartnerForm.controls['email']?.hasError('pattern')">
                            Invalid Email</span>
                    </div>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label for="phoneNumber" class="required-field">Phone Number :</label>
                <div>
                    <p-inputNumber id="phoneNumber" formControlName="phoneNumber" inputId="withoutgrouping"
                        [useGrouping]="false" autoWidth="false" [style]="{'width':'83.33%'}" [maxlength]="12"></p-inputNumber>
                    <div *ngIf="!newPartnerForm.controls['phoneNumber'].valid && newPartnerForm.controls['phoneNumber'].dirty"
                        class="error-msg">
                        <span *ngIf="newPartnerForm.controls['phoneNumber']?.hasError('required')">
                            Phone Number is required</span>
                        <span *ngIf="newPartnerForm.controls['phoneNumber']?.hasError('maxlength')">
                            Invalid Phone Number</span>
                    </div>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label for="state">Partner Type :</label>
                <div>
                    <p-dropdown [options]="newPartnerType" optionLabel="name" placeholder="Select Partner Type"
                        [showClear]="true" formControlName="partnerType" autoWidth="false" [style]="{'width':'83.33%'}">
                    </p-dropdown>
                </div>
            </div>


            <div class="field col-12 md:col-4">
                <label for="state">Country :</label>
                <div>
                    <p-dropdown [filter]="true" [options]="countryList" [showClear]="true" 
                        optionLabel="name" optionValue="name" placeholder="Select Country" 
                        formControlName="country" autoWidth="false" name="country"
                        [style]="{'width':'83.33%'}">
                    </p-dropdown>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label for="state">State :</label>
                <div>
                    <input id="city" type="text" class="w-10" pInputText formControlName="state">
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label for="state">City :</label>
                <div>
                    <input id="city" type="text" class="w-10" pInputText formControlName="city">
                </div>
            </div>

            <div class="field col-12 md:col-4">
                <label for="adminFirstName" class="required-field">Admin First Name : </label>
                <div>
                    <input id="adminFirstName" type="text" pInputText formControlName="adminFirstName" class="w-10">
                </div>
                <div *ngIf="!newPartnerForm.controls['adminFirstName'].valid && newPartnerForm.controls['adminFirstName'].dirty"
                    class="error-msg">
                    <span *ngIf="newPartnerForm.controls['adminFirstName']?.hasError('required')">
                        First Name is required</span>
                    <span *ngIf="newPartnerForm.controls['adminFirstName']?.hasError('pattern')">
                        FirstName should be characters only</span>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label for="adminMiddleName">Admin Middle Name : </label>
                <div>
                    <input id="adminMiddleName" type="text" pInputText formControlName="adminMiddleName" class="w-10">
                </div>

            </div>
            <div class="field col-12 md:col-4">
                <label for="adminLastName" class="required-field">Admin Last Name : </label>
                <div>
                    <input id="adminLastName" type="text" pInputText formControlName="adminLastName" class="w-10">
                </div>
                <div *ngIf="!newPartnerForm.controls['adminLastName'].valid && newPartnerForm.controls['adminLastName'].dirty"
                    class="error-msg">
                    <span *ngIf="newPartnerForm.controls['adminLastName']?.hasError('required')">
                        Last Name is required</span>
                    <span *ngIf="newPartnerForm.controls['adminLastName']?.hasError('pattern')">
                        Last Name should be characters only</span>
                </div>
            </div>


            <div class="field col-12 md:col-4">
                <label for="postCode" class="required-field">Post Code : </label>
                <div>
                    <input id="postCode" type="text" pInputText formControlName="postCode" class="w-10">
                </div>
                <div *ngIf="!newPartnerForm.controls['postCode'].valid && newPartnerForm.controls['postCode'].dirty"
                    class="error-msg">
                    <span *ngIf="newPartnerForm.controls['postCode']?.hasError('required')">
                        Post Code is required</span>
                    <span *ngIf="newPartnerForm.controls['postCode']?.hasError('pattern')">
                        Post Code should be alphanumeric</span>
                </div>
            </div>
            <div class="field col-12 md:col-4">
                <label for="VATno">VAT Number : </label>
                <div>
                    <input id="VATno" type="text" pInputText formControlName="VATno" class="w-10">
                </div>
            </div>
            <div class="field col-12 md:col-4" *ngIf="newPartnerForm.value.isTopconPartner === true && displayHeader === 'Add New Partner'">
                <label for="password" class="required-field">Password : </label>
                <div>
                    <p-password  formControlName="password" styleClass="w-10">
                        <ng-template pTemplate="header" >
                            <h6>Pick a password</h6>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <p-divider></p-divider>
                            <p class="mt-2">Suggestions</p>
                            <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                                <li [ngClass]="{'color': hasLowerCasePassed}">At least one lowercase</li>
                                <li [ngClass]="{'color': hasUpperCasePassed}">At least one uppercase</li>
                                <li [ngClass]="{'color': hasNumberPassed}">At least one numeric</li>
                                <li [ngClass]="{'color': hasSpecialCharactersPassed}">At least one special character</li>
                                <li [ngClass]="{'color' : stringLengthPassed}">Minimum 10 characters</li>
                            </ul>
                        </ng-template>
                    </p-password>
                </div>
            </div>
            <div class="field col-12 md:col-4" *ngIf="newPartnerForm.value.isTopconPartner === false">
                <label for="clientID">Client ID : </label>
                <div>
                    <input id="clientId" type="text" pInputText formControlName="clientId" class="w-10">
                </div>
                <!-- <div class="info-wrapper">
                    <span>
                        <i class="pi pi-info-circle"></i>Selected manufacturer must match specified PAC(s) for cancellation to succeed.
                    </span>
                </div> -->
                <div class="error-msg">
                    <span *ngIf="newPartnerForm.controls['clientId']?.hasError('pattern')">
                        Client ID should be alphanumeric with hyphen</span>
                </div>
            </div>
            <div class="flex">
                <div class="flex md:justify-content-start align-items-center justify-content-center w-8 m-2">
                    <label for="postalAddress" class="required-field">Postal Address : </label>
                </div>
                <textarea formControlName="postalAddress" pInputTextarea></textarea>
            </div>
        </div>


        <div class="flex justify-content-center flex-wrap">
            <div class="flex align-items-center justify-content-center w-5rem h-4rem font-bold border-round m-4">
                <button pButton type="button" label="Cancel" (click)="cancelDetails()" class="p-button-danger"
                    style="min-width: 100px"></button>
            </div>
            <div class="flex align-items-center justify-content-center w-5rem h-4rem font-bold border-round m-4">
                <button pButton type="button" label="Save" (click)="saveDetails(newPartnerForm.value)"
                    style="min-width: 100px" [disabled]="newPartnerForm.invalid"></button>
            </div>            
        </div>

    </form>
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" [ngClass]="{'errorcode':errorCode}">
    </p-confirmDialog>
</p-card>
<p-toast styleClass="custom-toast" life="10000" position="top-center"></p-toast>
